// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ec","heading":"Fc","items":"Gc","featureCss":"Hc","disabled":"Ic","imgCss":"Jc"};